<template>
  <v-app id="app">
    <!-- TODO temporary disabled Timer, need to improve and fix freezes -->
    <Timer v-if="false" />
    <SiteMenu v-if="showSiteMenu" v-show="showSiteMenu" :key="siteMenuKey" class="menu" />

    <router-view :key="$route.fullPath" />

    <LogInParentModal />
    <ForgotPasswordModal />
  </v-app>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  components: {
    Timer: () => import('@/components/Timer'),
    SiteMenu: () => import('@/components/site-menu/SiteMenu'),
    LogInParentModal: () => import('@/components/modals/LogInParentModal'),
    ForgotPasswordModal: () => import('@/components/ForgotPasswordModal'),
  },
  data() {
    return {
      cookiesWatcher: null,
    };
  },
  computed: {
    ...mapGetters({
      parentAccount: 'parent/parentAccount',
      activeChildProfile: 'children/activeChildProfile',
    }),
    showSiteMenu() {
      return this.siteMenuKey && this.$route.meta.showMenuWidget !== false;
    },
    siteMenuKey() {
      if (!this.activeChildProfile) return null;
      const { id, avatar, nickname } = this.activeChildProfile;
      return id + avatar + nickname;
    },
  },
  created() {
    this.detectIsUserLoggedIn();

    if (this.activeChildProfile) {
      this.loadChildProfile();
    }

    if (this.parentAccount) {
      this.loadParentAccount();
    }

    this.$store.subscribe((mutation) => {
      if (mutation.type === 'children/SET_ACTIVE_CHILD_ID') {
        this.trackActivity(mutation.payload.id);
      }
    });

    this.cookiesWatcher = setInterval(() => this.detectIsUserLoggedIn(), 2000);
  },
  beforeDestroy() {
    clearInterval(this.cookiesWatcher);
  },
  methods: {
    ...mapActions({
      loadChildProfile: 'children/loadChildProfile',
      setParentData: 'parent/setParentData',
      logoutParent: 'parent/logoutParent',
      loadParent: 'parent/loadParent',
    }),
    trackActivity(id) {
      if (this.activeChildProfile) {
        this.$gtag.config({
          user_id: id,
        });
      }
    },
    detectIsUserLoggedIn() {
      const parent = this.$cookies.get('parent');
      if (parent && (!this.parentAccount?._id || (parent._id !== this.parentAccount._id))) {
        this.setParentData(parent);
      } else if (!parent && this.parentAccount?._id) {
        this.logoutParent();
        this.$router.go();
      }
    },
    async loadParentAccount() {
      try {
        await this.loadParent();
      } finally {
        if (this.activeChildProfile) {
          // TODO load notifications, messages, events and navigation drawer info with websocket
        }
      }
    },
  },
};
</script>

<style lang="scss">
@import "./scss/app";
@import "./scss/fonts/icons";

#app {
  font-family: 'Montserrat';
}

@font-face {
  font-family: "iconsmind";
  src: url("./scss/fonts/iconsmind.eot?#iefix-rdmvgc") format("embedded-opentype");
  src: url("./scss/fonts/iconsmind.woff") format("woff"),
    url("./scss/fonts/iconsmind.ttf") format("truetype");
  font-weight: normal;
  font-style: normal;
}

input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
input:-webkit-autofill:active {
  -webkit-text-fill-color: #fff;
  -webkit-box-shadow: 0 0 0 1000px #474747 inset;
  transition: background-color 5000s ease-in-out 0s;
}
</style>
